// extracted by mini-css-extract-plugin
module.exports = {"panels":"help-and-support_panels__XSxaO","title":"help-and-support_title__vNSQ4","faqWrapper":"help-and-support_faqWrapper__nRq63"};